const addClassToSelector = (selector, className) =>
    document.querySelector(selector)?.classList.add(className);
const removeClassFromSelector = (selector, className) =>
    document.querySelector(selector)?.classList.remove(className);

export { addClassToSelector, removeClassFromSelector };
